import React from 'react';

const DISCIPLINES = [
  'Agriculture & Food Sciences',
  'Architecture & Urban Planning',
  'Arts & Humanities',
  'Built Environment & Construction',
  'Business & Management',
  'Computer Science & Artificial Intelligence',
  'Economics & Finance',
  'Education & Pedagogy',
  'Engineering & Technology',
  'Environmental Sciences & Sustainability',
  'Health Sciences & Medicine',
  'Law & Legal Studies',
  'Natural Sciences (Biology, Chemistry, Physics)',
  'Psychology & Behavioural Sciences',
  'Social Sciences & Sociology',
  'Other',
];

export default function Step1_Context({ data, onChange, onNext }) {
  const update = (field, val) => onChange({ ...data, [field]: val });

  const handleKeywordChange = (index, val) => {
    const kws = [...(data.keywords || Array(10).fill(''))];
    kws[index] = val;
    update('keywords', kws);
  };

  const filledKeywords = (data.keywords || []).filter((k) => k.trim() !== '');
  const canProceed =
    data.topic?.trim() &&
    data.discipline &&
    data.academicLevel &&
    filledKeywords.length >= 7;

  return (
    <div className="gf-step">
      <div className="gf-step-header">
        <span className="gf-step-badge">Phase 1</span>
        <h2>Research Context</h2>
        <p>Provide the topic, discipline and at least 7 keywords to guide the gap detection engine.</p>
      </div>

      <div className="gf-form-grid">
        <div className="gf-field gf-field-full">
          <label>Research Topic / Title *</label>
          <input
            type="text"
            placeholder="e.g. Digital Transformation in Higher Education"
            value={data.topic || ''}
            onChange={(e) => update('topic', e.target.value)}
          />
        </div>

        <div className="gf-field">
          <label>Discipline *</label>
          <select value={data.discipline || ''} onChange={(e) => update('discipline', e.target.value)}>
            <option value="">— Select —</option>
            {DISCIPLINES.map((d) => <option key={d}>{d}</option>)}
          </select>
        </div>

        <div className="gf-field">
          <label>Academic Level *</label>
          <select value={data.academicLevel || ''} onChange={(e) => update('academicLevel', e.target.value)}>
            <option value="">— Select —</option>
            <option value="Undergraduate">Undergraduate</option>
            <option value="Masters">Master's</option>
            <option value="PhD">PhD / Doctoral</option>
          </select>
        </div>
      </div>

      <div className="gf-keywords-section">
        <label className="gf-keywords-label">
          Keywords (enter 7–10) * <span className="gf-kw-count">{filledKeywords.length}/10 entered</span>
        </label>
        <div className="gf-keywords-grid">
          {Array(10).fill(null).map((_, i) => (
            <div key={i} className="gf-kw-input-wrap">
              <span className="gf-kw-num">{i + 1}</span>
              <input
                type="text"
                placeholder={`Keyword ${i + 1}${i < 7 ? ' *' : ''}`}
                value={(data.keywords || [])[i] || ''}
                onChange={(e) => handleKeywordChange(i, e.target.value)}
              />
            </div>
          ))}
        </div>
        {filledKeywords.length < 7 && (
          <p className="gf-hint gf-warn">Please enter at least 7 keywords.</p>
        )}
      </div>

      <div className="gf-nav">
        <button className="gf-btn gf-btn-primary" onClick={onNext} disabled={!canProceed}>
          Next: Add Abstracts →
        </button>
      </div>
    </div>
  );
}
